<script>
    import { navigate } from 'svelte-routing'
    import date from 'date-and-time'

    import { Functions } from '../../config/firebase'
    import { Agents } from '../../middleware/database/agents'
    import { currentUser } from '../../stores/current_user'

    import Form from './form.svelte'
    import { Spinner } from 'sveltestrap'

    export let id

    let saving = false
    let loading = true
    let agent = {}

    const ensureFormFields = (agent) => {
        const safeAgent = {
            name: agent.name || '',
            email: agent.email || '',
            password: agent.password || '',
            active: agent.active || true,
            role: agent.role || 'user',
            phoneNumber: agent.phoneNumber || '',
            address: {
                address1: (agent.address && agent.address.address1) || '',
                address2: (agent.address && agent.address.address2) || '',
                postalCode: (agent.address && agent.address.postalCode) || '',
                city: (agent.address && agent.address.city) || '',
                country: (agent.address && agent.address.country) || '',
                state: (agent.address && agent.address.state) || null
            }
        }
        return safeAgent
    }

    const ensureAddress = (delta) => {
        if (delta.address) {
            const address = {
                address1: delta.address.address1 || ((agent.address && agent.address.address1) || null),
                address2: delta.address.address2 || ((agent.address && agent.address.address2) || null),
                postalCode: delta.address.postalCode || ((agent.address && agent.address.postalCode) || null),
                city: delta.address.city || ((agent.address && agent.address.city) || null),
                country: delta.address.country || ((agent.address && agent.address.country) || null),
                state: delta.address.state || ((agent.address && agent.address.state) || null),
            }
            delta.address = address
        }
        return delta
    }

    $: if (loading) {
        Agents.findOne(id).then(doc => {
            agent = ensureFormFields(doc)
            loading = false
        })
    }

    function updateHandler(event) {
        saving = true
        let delta = event.detail
        delta.id = id
        delta = ensureAddress(delta)

        const updateAgent = Functions.httpsCallable('updateAgent')
        updateAgent(delta)
            .then((reply) => {
                saving = false
                navigate('/agents')
            }, err => {
                alert('Could not update agent!')
                console.log('Save Agent:', err)
                saving = false
            })
    }
</script>

{#if !loading && !saving}
<Form pageTitle="Edit agent" {agent} on:submit={updateHandler} />
{:else}
<Spinner size="lg" color="dark" type="grow" />
{/if}